module.exports = __webpack_public_path__ + "static/media/astro-sprite-left.0e3b1382.png";